import { createSelector } from 'reselect'

const selectCompanyState = (state: any) => state.companyData

export const selectCompanyData = createSelector([selectCompanyState], (companyState) => companyState.companyData)

export const selectCompanyLoading = createSelector([selectCompanyState], (companyState) => companyState.loading)

export const selectCompanyError = createSelector([selectCompanyState], (companyState) => companyState.error)
